/* ============================================================
   YAMA FUKU MATCHA — main.js
   共通JavaScript：スクロール・モバイルナビ・アニメーション
   ============================================================ */

(function () {
  'use strict';

  /* ----------------------------------------------------------
     1. ヘッダー：スクロールでスタイル切替
     ---------------------------------------------------------- */
  const header = document.querySelector('.site-header');

  function updateHeader() {
    if (!header) return;
    const scrolled = window.scrollY > 60;
    header.classList.toggle('site-header--scrolled', scrolled);
  }

  window.addEventListener('scroll', updateHeader, { passive: true });
  updateHeader(); // 初期化

  /* ----------------------------------------------------------
     2. モバイルナビゲーション
     ---------------------------------------------------------- */
  const navToggle = document.querySelector('.nav-toggle');
  const siteNav   = document.querySelector('.site-nav');
  const body      = document.body;

  if (navToggle && siteNav) {
    navToggle.addEventListener('click', function () {
      const isOpen = siteNav.classList.toggle('is-open');
      navToggle.classList.toggle('is-open', isOpen);
      navToggle.setAttribute('aria-expanded', isOpen);
      body.style.overflow = isOpen ? 'hidden' : '';
    });

    // ナビリンクをクリックしたら閉じる
    siteNav.querySelectorAll('.site-nav__link, .site-nav__cta').forEach(link => {
      link.addEventListener('click', () => {
        siteNav.classList.remove('is-open');
        navToggle.classList.remove('is-open');
        navToggle.setAttribute('aria-expanded', 'false');
        body.style.overflow = '';
      });
    });
  }

  /* ----------------------------------------------------------
     3. スクロールリビール（Intersection Observer）
     ---------------------------------------------------------- */
  const revealElements = document.querySelectorAll('.reveal');

  if (revealElements.length > 0) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target); // 一度だけ
          }
        });
      },
      {
        threshold: 0.12,
        rootMargin: '0px 0px -40px 0px'
      }
    );

    revealElements.forEach(el => observer.observe(el));
  }

  /* ----------------------------------------------------------
     4. アクティブナビリンク（現在ページのマーク）
     ---------------------------------------------------------- */
  const currentPath = window.location.pathname;
  document.querySelectorAll('.site-nav__link').forEach(link => {
    const href = link.getAttribute('href');
    if (href && (href === currentPath || currentPath.startsWith(href) && href !== '/')) {
      link.classList.add('is-active');
    }
  });

  /* ----------------------------------------------------------
     5. スムーススクロール（アンカーリンク）
     ---------------------------------------------------------- */
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (!target) return;
      e.preventDefault();
      const offset = parseInt(getComputedStyle(document.documentElement)
        .getPropertyValue('--nav-height')) || 72;
      const top = target.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    });
  });

})();

/* ----------------------------------------------------------
   6. Productsページ フィルタータブ
   ---------------------------------------------------------- */
(function () {
  var tabs  = document.querySelectorAll('.filter-tab');
  var cards = document.querySelectorAll('.product-card');
  if (!tabs.length || !cards.length) return;

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      tabs.forEach(function (t) { t.classList.remove('is-active'); });
      tab.classList.add('is-active');
      var filter = tab.getAttribute('data-filter');
      cards.forEach(function (card) {
        var tags = card.getAttribute('data-tags') || '';
        if (filter === 'all' || tags.indexOf(filter) !== -1) {
          card.style.display = '';
        } else {
          card.style.display = 'none';
        }
      });
    });
  });
})();
